import React, { useState } from 'react';
import { api } from '../lib/api';
import { Check, ArrowUpRight } from 'lucide-react';

// Reusable lead form. Stores in Admin (leads) and records the intended recipient + Cc founder.
export default function LeadForm({ type, recipient, heading, extraFields = [], cta = 'Submit', accent = '#D01919', downloadUrl = null, cc = 'founder@enersider.com', note = null }) {
  const [f, setF] = useState({});
  const [sent, setSent] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const inp = 'mt-1.5 w-full bg-white rounded-xl px-4 py-3 outline-none border border-neutral-200 focus:ring-2 focus:ring-black transition text-sm';
  const submit = async (e) => {
    e.preventDefault();
    try { await api.createLead({ type, recipient, ...(cc ? { cc } : {}), ...f }); } catch (_) {}
    setSent(true); setF({});
    if (downloadUrl) { setRevealed(true); window.open(downloadUrl, '_blank'); }
    setTimeout(() => setSent(false), 4500);
  };
  const base = [{ k: 'name', l: 'Full name', req: true }, { k: 'organisation', l: 'Organisation' }, { k: 'email', l: 'Email', type: 'email', req: true }, { k: 'phone', l: 'Phone' }];
  const fields = [...base, ...extraFields];
  return (
    <form onSubmit={submit} className="bg-[#f4f4f4] rounded-3xl p-7 md:p-9">
      {heading ? <h3 className="font-display text-2xl mb-5">{heading}</h3> : null}
      {note}
      <div className="grid sm:grid-cols-2 gap-4">
        {fields.map((fl) => (
          <div key={fl.k} className={fl.full ? 'sm:col-span-2' : ''}>
            <label className="text-sm font-medium">{fl.l}</label>
            {fl.options ? (
              <select required={fl.req} value={f[fl.k] || ''} onChange={set(fl.k)} data-testid={`leadform-${fl.k}`} className={inp}>
                <option value="" disabled>Select…</option>
                {fl.options.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : fl.area ? <textarea rows={3} value={f[fl.k] || ''} onChange={set(fl.k)} data-testid={`leadform-${fl.k}`} className={`${inp} resize-none`} />
              : <input type={fl.type || 'text'} required={fl.req} value={f[fl.k] || ''} onChange={set(fl.k)} data-testid={`leadform-${fl.k}`} className={inp} />}
          </div>
        ))}
      </div>
      <button type="submit" data-testid="leadform-submit" className="mt-6 inline-flex items-center gap-2 text-white font-medium px-6 py-3.5 rounded-full transition-opacity hover:opacity-90" style={{ background: accent }}>
        {sent ? (<><Check size={18} /> Received — thank you</>) : (<>{cta} <ArrowUpRight size={18} /></>)}
      </button>
      {revealed && downloadUrl ? (
        <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 font-medium text-sm underline" style={{ color: accent }}>Your download is ready — click here if it didn’t open</a>
      ) : null}
      <p className="text-xs text-neutral-500 mt-3">Your details go to {recipient}{cc ? ` (Cc ${cc})` : ''} and are saved in our system.</p>
    </form>
  );
}
